import './styles.scoped.css';
import { Helmet } from 'react-helmet-async';
//import EmailForm from '../EmailForm/EmailForm';
import { Col, Row, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import AnimateScreen from '../AnimateScreen/AnimateScreen';
//import CookiesForm from '../CookiesForm/CookiesForm';
//import pliki from "../../jsondata/pliki.json";
import postsData from "../../jsondata/posty.json";
import { PostType } from "../../types/PostType";
import imgData from "../../jsondata/img_path.json";
import statystyki from '../../jsondata/statystyki.json';

interface ContentProps {
};


const Content: React.FC<ContentProps> = ({ }) => {
  const ostatniPost: PostType = postsData[postsData.length - 2];
  const powiazaneZdjecie = imgData.find(img => img.ID === ostatniPost.fileID);
  const imageUrl = powiazaneZdjecie
  ? `/images_photo/${powiazaneZdjecie.filename}`
  : '/images_photo/default.jpg'; 
  const altText = powiazaneZdjecie?.alt || "Obrazek do posta";

  return (
    <main className="content-m">
      <Helmet>
        <title>Teambit – koło naukowe Politechniki Opolskiej</title>
      </Helmet>
      {/* <CookiesForm /> */}
      {/* <Container className='Container-main'> */}
        <Row className="welcome">
          <Col sm={12} lg={5} className='hero'>
            <h1>studenckie koło naukowe<span className="teambitMain">TEAMBIT</span></h1>
            
          </Col>
          <Col sm={12} lg={6}>
            <Row>
              <AnimateScreen />
            </Row>
          </Col>
         
          <Col>
          <div className="grid">
            <div className="backg-w"></div>
            <div className="backg-b"></div>
            <div className="backg-w"></div>
            <div className="backg-w"></div>
            <div className="backg-b"></div>
            <div className="backg-w"></div>
            <div className="backg-b"></div>
            <div className="backg-w"></div>
            <div className="backg-w"></div>
            <div className="backg-w"></div>
            <div className="backg-b"></div>
            <div className="backg-w"></div>
            <div className="backg-w"></div>
            <div className="backg-b"></div>
            <div className="backg-w"></div>
            <div className="backg-w"></div>
            <div className="backg-b"></div>
            <div className="backg-w"></div>
            <div className="backg-b"></div>
            <div className="backg-w"></div>
           
            <div className="backg-b"></div>
            <div className="backg-w"></div>
            <div className="backg-b"></div>
            <div className="backg-w"></div>
            <div className="backg-b"></div>
            <div className="backg-b"></div>
            <div className="backg-w"></div>
            <div className="backg-b"></div>
            <div className="backg-w"></div>
            <div className="backg-b"></div>
            <div className="backg-b"></div>
            <div className="backg-b"></div>
            <div className="backg-b"></div>
            <div className="backg-w"></div>
            <div className="backg-b"></div>
            <div className="backg-w"></div>
            <div className="backg-b"></div>
            <div className="backg-b"></div>
            <div className="backg-w"></div>
            <div className="backg-b"></div>
          </div>
        </Col>   
        </Row>

        <div className="activities">
            <h2 className='headline-h2'>Wydarzenia</h2>
              <div className="event-box">
                <img src={imageUrl} alt={altText} className='event-image'/>
                
                <div className="text-block">
                  <h3>{ostatniPost.title}</h3>
                  <small>{ostatniPost.postAddDate}</small>
                  <p>{ostatniPost.description.slice(0, 160)}...</p>
                  
                  <div className="post_bottom">
                      <small className="event-author">autor: {ostatniPost.autor}</small>
                      <Link to="/aktualnosci">
                        <Button className="btn-add">więcej...</Button>
                      </Link>
                  </div>
                </div>
              </div>
        </div>

        <Row className="text-center mt-4">
          <Link to="/aktualnosci">
            <Button className="btn-primary">zobacz więcej wydarzeń</Button>
          </Link>
        </Row>

        <Row className="whoarewe">
          <Row className='headline'>
            <h2>Kim jesteśmy?</h2>
          </Row>
          <Row className="articalBoxes">
            <Col sm={11} md={11} lg={3}>
              <Row>
                <h3>Programujemy</h3>
                
              </Row>
              <Row>
                <article className='boxtextholder'>
                  <p className='articalText'>Rozwiązujemy zadania programistyczne i implementujemy ciekawe algorytmy.
                    Nie wystarczy rozwiązać problem - należy go jeszcze zaimplementować w taki sposób, aby kod działał szybko i uniwersalnie.
                    Wówczas dobra znajomość języka programowania to podstawa! </p>
                </article>
              </Row>
            </Col>
            <Col sm={11} md={11} lg={3}>
              <Row>
                <h3>Rozwijamy się</h3>
                
              </Row>
              <Row>
                <article className='boxtextholder'>
                  <p className='articalText'>Doskonalimy nasze rozwiązania i samych siebie. Uczymy się od siebie nawzajem, by
                    by wspólnymi siłami otrzymać jak najlepsze rezultaty. Nic tak nie cieszy jak dobrze zoptymalizowany kod! </p>
                </article>
              </Row>
            </Col>
            <Col sm={11} md={11} lg={3}>
              <Row>
                <h3>Uczymy innych</h3>
                
              </Row>
              <Row>
                <article className='boxtextholder'>
                  <p className='articalText'>Organizujemy warsztaty dla naszych członków i nie tylko - do
                    wspólnej nauki zapraszamy także uczniów szkół oraz innych gości. Brak umiejętności programistycznych nie jest
                    problemem, staramy się przede wszystkim zarazić pasją do rozwiązywania zadań przy użyciu logiki
                    oraz algorytmów. </p>
                </article>
              </Row>
            </Col>
          </Row>
        </Row>
        <Row className='achives'>
          <Col sm={11} lg={11}>
          <section className='headline'>
            <h2>Osiągnięcia</h2>
          <article className='hold'>
          </article>
          <Row>
            <article className='achive-item'>
              Wielokrotny udział w Akademickich Mistrzostwach Polski w Programowaniu Zespołowym
            </article>
          </Row>
          <Row>
            <article className='achive-item'>
              Urozmaicony zbiór wspólnie rozwiązanych problemów algorytmicznych i programistycznych
            </article>
          </Row>
          <Row>
            <article className='achive-item'>
              Udział w eliminacjach do finałów International Collegiate Programming Contest
            </article>
          </Row>
          <Row>
            <article className='achive-item'>
              Organizacja Otwartych Mistrzostwach Opola w Programowaniu Zespołowym dla szkół średnich
            </article>
          </Row>
          <Row>
            <article className='achive-item'>
              Stale powiększający się skład koła
            </article>
          </Row>
        </section>
        </Col>
      </Row>
      
      <Row className="statistic">
        <Col className="statistic-item" sm={12} lg={3}>
          <div className='s-item'>
            <Row className='s-item-img'>
              <img src="icon1.png" alt="icon" />
            </Row>
            <Row>
              <p>obecnie mamy</p><br/>
              <p className='s-number'>{statystyki.iloscCzlonkow}</p><br/>
              <p>aktywnych członków</p>
            </Row>
          </div>
        </Col>
        <Col className="statistic-item" sm={12} lg={3}>          
          <div className='s-item'>
            <Row className='s-item-img'>
              <img src="icon2.png" alt="icon" />
            </Row>
            <Row>
              <p>rozwiązaliśmy wspólnie</p><br/>
              <p className='s-number'>{statystyki.rozwiazaneZadania}</p><br/>
              <p>zadań</p>
            </Row>
          </div>
        </Col>
        <Col className="statistic-item" sm={12} lg={3}>          
          <div className='s-item'>
            <Row className='s-item-img'>
              <img src="icon3.png" alt="icon" />
            </Row>
            <Row>
              <p>wzięliśmy udział w</p><br/>
              <p className='s-number'>{statystyki.iloscKonferencji}<br/></p>
              <p>konferencjach IT</p>
            </Row>
          </div>
        </Col>
        <Col className="statistic-item" sm={12} lg={3}>          
          <div className='s-item'>
            <Row className='s-item-img'>
              <img src="icon4.png" alt="icon" />
            </Row>
            <Row>
              <p>przeprowadziliśmy</p><br/>
              <p className='s-number'>{statystyki.iloscWarsztatow}</p><br/>
              <p>warsztatów</p>
            </Row>
          </div>
        </Col>                      
      </Row>

        <Row className="moreinfo">
          <Row className="contact_i">
            <h2>Potrzebujesz więcej informacji lub chcesz dołączyć do koła?</h2>
          </Row>
          <Row className="contact_i">
            <Col sm={10} lg={3}>
              <Link to="/contact">
                        <Button className="btn-primary">Skontaktuj się z nami!</Button>
              </Link>
            </Col>
          </Row>
        </Row>
      {/* </Container> */}
    </main>
  );
}

export default Content;
